//
// Copyright 2025 DXOS.org
//

// TODO(burdon): Reconcile with artifact-testing.
export const AI_SERVICE_ENDPOINT = {
  LOCAL: 'http://localhost:8788',
  REMOTE: 'https://ai-service.dxos.workers.dev',
};

// TODO(burdon): Move to config.
export const EXA_API_KEY = '9c7e17ff-0c85-4cd5-827a-8b489f139e03';
